<template>
    <rkm-row>
        <rkm-col cols="12">

            <rkm-form-checkbox v-model="data.model.exibirReagendarExame">
                Se ativo, exibirá a mensagem para reagendar os exames não coletados.
            </rkm-form-checkbox>
        </rkm-col>
    </rkm-row>
</template>

<script>

export default {
    computed: {
        validations() {

            return {
                impressaoAgendamento: { required: true},
            }
        },
    },
    props: {
        data: { type: Object, required: true },
    },
}
</script>